module.exports = __webpack_public_path__ + "img/calendar-check-icon.dbc49c2a.svg";